"use client"

import {
  useMemo 
} from "react"

import {
  useStyle 
} from "@/classify"
import defaultClasses from "./shimmer.module.css"

const Shimmer = (props) => {
  const {
    classes: propClasses,
    borderRadius,
    height,
    width,
    style: customStyles = {},
    type = "rectangle",
    children,
    ...restProps
  } = props
  const classes = useStyle(defaultClasses, propClasses)

  const style = useMemo(() => {
    const combinedStyles = {
      ...customStyles,
    }

    Object.entries({
      borderRadius, height, width 
    }).forEach(([type, value]) => {
      if (typeof value !== "undefined") {
        combinedStyles[type] =
                        typeof value === "number" ? `${value}rem` : value
      }
    })

    return combinedStyles
  }, [customStyles, borderRadius, height, width])

  const rootClass = `root_${type}`

  return (
    <div className={classes[rootClass]} style={style} {...restProps}>
      {children}
    </div>
  )
}

export default Shimmer
